import styles from './EquipmentList.module.scss';
import classNames from 'classnames';
import {
	EquipmentCard,
	SortingParameter,
	Button,
	Heading,
} from 'ui/components';
import { useContext, useEffect, useState } from 'react';
import { Container } from 'ui/components/4-habitats';
import { PageSpinner } from 'ui/components/1-atoms/Media/PageSpinner';
import { PaginationWithButtonsProps } from 'ui/components/2-molecules/Navigation/Pagination/PaginationWithButtons';
import { ReactComponent as IconArrowLeft } from 'ui/icons/icon_arrow_left.svg';
import { useRouter } from 'next/router';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export interface EquipmentListProps {
	className?: string;
	columns?: number;
	numberOfProducts: number;
	equipments: Models.Equipment[];
	filterSettings?: {
		priceRangeMinMax: [number, number];
	};
	sortingSettings?: SortingParameter[];
	paginationData?: PaginationWithButtonsProps;
	isLoggedIn: boolean;
	isLoadStory?: boolean;
	facets?: {
		count: number;
		name: string;
		displayName: string;
		facetvalues: { value: string; count: number }[];
	}[];
	handleFacetsChanged: (name: string, value: string) => void;
	hasBp: boolean;
}

export const EquipmentList = ({
	className,
	columns,
	equipments,
	numberOfProducts,
	filterSettings,
	sortingSettings,
	isLoggedIn,
	isLoadStory = false,
	hasBp,
}: EquipmentListProps) => {
	const [filters] = useState<{ priceRange: [number, number] }>({
		priceRange: [filterSettings?.priceRangeMinMax[0], filterSettings?.priceRangeMinMax[1]],
	});
	const [sortingParameter, setSortingParameter] = useState<SortingParameter>({
		parameter: sortingSettings && sortingSettings[0].parameter,
		text: sortingSettings && sortingSettings[0].text,
	});
	
	const router = useRouter();

	// Gets column width for Product Card
	const getColumnWidth = (columns: number) => {
		if (columns > 4) columns = 4;
		if (!columns || columns === 1) columns = 2;
		const columnsWidth = Math.round(100 / columns);
		return JSON.stringify(columnsWidth) as Models.GridCellWidth;
	};
	const columnWidth = getColumnWidth(columns);

	// Defines image sizes for Product Card
	const imageSizes = '(max-width: 768px) 50vw, ' + columnWidth + 'vw';
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const dictionary = useContext(DictionaryContext);
	const handlePrevious = () => {
		router.push('/my-account');
	  };

	useEffect(() => {
		setIsLoading(isLoadStory);
	}, [isLoadStory]);

	return (
		<Container width="Standard">
			<div className={classNames(styles.EquipmentList)}>
			<Heading
					headingLevel="h1"
					style="xl"
					className={classNames(
						styles.AddressSelector_title,
						'u-bottom-margin--md',
					)}
				>
				{dictionary.getValue(
					'LabOverview.Heading',
					null,
					'My equipment',
				)}
				</Heading>
				<Button
					style="primary"
					className={classNames(
						styles.StepNavigation_buttonPrevious, styles.EquipmentList_backBtn
					)}
					onClick={handlePrevious}							
				>
					<IconArrowLeft
						className={
							styles.StepNavigation_buttonPrevious___iconLeft
						}
					/>					
					{dictionary.getValue(
						'LabOverview.Back',
						null,
						'Back to Dashboard',
					)}
				</Button>
				{isLoadStory ? (
					<PageSpinner size="large" />
				) : (					
					<section className={classNames(styles.EquipmentListWrapper, className)}>
						<div className={classNames(styles.EquipmentListItems, className)}>
							{equipments
								?.slice(0, numberOfProducts)
								.map((equipment, index) => (
								<EquipmentCard
									key={equipment?.sku ?? `equipment-${index}`} // fallback to index if sku is missing
									equipment={equipment as Models.Equipment}
									columnWidth={columnWidth}
									imageSizes={imageSizes}
									isLoggedIn={isLoggedIn}
									hasBp={hasBp}
								/>
								))}
						</div>
					</section>				
				)}
				
			</div>
		</Container>
	);
};
